import type { departments as en } from '@/i18n/locales/en/departments';
import type { Translation } from '@/i18n/types';

export const departments: Translation<typeof en> = {
  page: {
    title: 'Departmanlar',
    leadPersonal: 'Üyesi olduğunuz departmanlar.',
    leadCompany: '{{company}} içindeki departmanlar.',
  },
  list: {
    cardTitle: 'Departmanlar',
    name: 'Ad',
    company: 'Şirket',
    statistics: 'İstatistikler',
    collectiveConsent: 'Toplu rıza',
    inForce: 'yürürlükte',
    none: '—',
    unattached: 'bağlı değil',
    empty: 'Burada henüz departman yok.',
    newDepartment: 'Yeni departman',
  },
  compare: {
    cardTitle: 'Departman karşılaştırması',
    pageTitle: 'Departman karşılaştırması',
    lead: 'İstatistiklerini görebildiğiniz departmanların karşılaştırması.',
    empty: 'Burada görebileceğiniz istatistiklere sahip bir departman yok.',
  },
  detail: {
    thisDepartment: 'departman',
    edit: 'Düzenle',
    setVisibility: 'Görünürlüğü ayarla',
    collectiveConsent: 'Toplu rıza',
    coach: 'Koç',
    category: 'Kategori',
    type: 'Tür',
    statistics: 'İstatistikler',
    notRecorded: 'kaydedilmedi',
    membersCardTitle: 'Üyeler',
    statsCardTitle: 'İstatistikler',
    settingsCardTitle: 'Ayarlar',
    addPerson: 'Kişi ekle',
    name: 'Ad',
    nickname: 'Takma ad',
    login: 'Giriş',
    yes: 'evet',
    no: 'hayır',
    noMembers: 'Üye yok.',
  },
  form: {
    newTitle: 'Yeni departman',
    newLead:
      'Her yeni departman yalnızca toplu veriyle başlar — gizliliği koruyan durum, hiçbir şey yapmadan elde ettiğiniz durumdur.',
    name: 'Ad',
    category: 'Kategori',
    type: 'Tür',
    cancel: 'İptal',
    create: 'Departman oluştur',
    editTitle: 'Departmanı düzenle',
    save: 'Kaydet',
    deleteCardTitle: 'Sil',
    deleteButton: 'Bu departmanı sil',
    deleteConfirm: '{{name}} kalıcı olarak silinsin mi?',
    deleteKeep: 'Sakla',
    deleteYes: 'Evet, sil',
    visibilityTitle: 'İstatistik görünürlüğü',
    visibilityLead:
      'bireysel, tek başına kimseyi ifşa etmez: bir rıza dayanağının üyeyi kapsadığı yerde bireysel erişime izin verir. Toplu bir kayıt olmadan bireysele geçmek, mevcut her üye için bekleyen bir rıza kaydı oluşturur.',
    visibilityAggregate: 'toplu — yalnızca grup sayıları',
    visibilityIndividual: 'bireysel — rızanın kapsadığı yerde üye bazında erişim',
    collectiveConsentTitle: 'Toplu rıza dayanağı',
    collectiveConsentLead:
      'Toplu bir kayıt yürürlükte olduğu sürece, kişisel yanıtları ne olursa olsun {{name}}’in tüm üyelerini kapsar. Üyelerin kendi kayıtları saklanır ve kayıt iptal edildiğinde yeniden geçerli olur.',
    collectiveConsentNote: 'Platform dışı anlaşma (tam olarak belirtin)',
    collectiveConsentRecord: 'Toplu dayanağı kaydet',
    revokeCardTitle: 'İptal et',
    revokeButton: 'Toplu dayanağı iptal et',
  },
};
